export var isResponsiveProp = function(value) {
    return (value === null || value === void 0 ? void 0 : value.mobileAndAbove) !== undefined;
};
